import React from "react";
import Footer from "./Footer";
import { Link } from "react-router-dom";
import { OrientationContext } from "../provider/OrientationProvider";
import { device, MAX_WIDTH_STR } from "../model/Const";
import { IUADevice, userAgentInfo } from "../model/UserAgentInfo";
import styled from "styled-components";

const MessageDiv = styled.div`
	font-size: "2rem"
	
    @media ${device.mobileS} {
		font-size: 1rem;
    }
    @media ${device.mobileM} {
		font-size: 1.2rem;
    }
    @media ${device.mobileL} {
		font-size: 1.4rem;
    }
    @media ${device.tablet} {
		font-size: 1.6rem;
    }
`;

const LinkSpan = styled.span`
	color: white;
	font-size: 2.5rem;
	font-weight: bold;
    @media ${device.mobileS} {
		font-size: 1.2rem;
    }
    @media ${device.mobileM} {
		font-size: 1.4rem;
    }
    @media ${device.mobileL} {
		font-size: 1.6rem;
    }
    @media ${device.tablet} {
		font-size: 1.8rem;
    }
`;

const NoMatch: React.FC = () => {
	// useContext
	const context = React.useContext( OrientationContext );

	// 高さを設定
	const innerHeight90per = React.useMemo( () => {
		return window.innerHeight * 0.9 + "px";
	}, [context.resize] );

	return <>

		{/*メインへ戻る*/}
		<header style={{
			width: "100%",
			height: innerHeight90per,
			backgroundColor: "#df003a",
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			color: "white",
			flexDirection: "column"
		}}>
			<MessageDiv>
				URLに誤りがあります
			</MessageDiv>
			<Link to="" style={{
				cursor: "pointer",
			}}>
				<LinkSpan>
					eComicシリーズ TOPへ戻る
				</LinkSpan>
			</Link>
		</header>

		{/*フッター*/}
		<Footer
			style={userAgentInfo.device !== IUADevice.pc ? undefined : {
				maxWidth: MAX_WIDTH_STR,
				margin: "auto"
			}}
		/>
	</>;
};

export default NoMatch;